import { apiTypes } from 'shared/consts/handbooksApiTypes';

const config = {
  schema: '',
  table: 'accelerometer_params',
  title: 'Ограничения для показаний акселерометра',
  apiType: apiTypes.REPORT_API,
  connections: {
    names: {
      table: 'dqa_group',
      apiType: apiTypes.REPORT_API,
      index: 'id',
      fields: ['group_name'],
      format: (elem: any) => elem['name'],
    }
  },
  fields: [
    {
      name: 'accelerometer_param_id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
      disableFilter: true,
    },
    {
      name: 'name',
      title: 'Наименование',
      type: 'text',
      required: true,
      validate: (value: any) => /^[A-Za-z-А-Яа-я-0-9_-]+$/.test(value),
      validateError: 'Допустимы только буквы, цифры и знаки "_" и "-"',
      width: '14%',
      maxLengthValue: 255
    },
    {
      name: 'group',
      title: 'Группа',
      type: 'number',
      required: true,
      width: '14%',
      connection: 'names'
    },
    {
      name: 'priority',
      title: 'Приоритет манёвра в группе',
      type: 'number',
      required: true,
      width: '14%',
    },
    {
      name: 'value',
      title: 'Вес (оценка) манёвра',
      type: 'number',
      required: true,
      width: '14%',
    },
    {
      name: 'axis',
      title: 'Ось акселерометра',
      type: 'list',
      values: [
        {
          key: 'X',
          value: 'X',
        },
        {
          key: '-X',
          value: '-X',
        },
        {
          key: '+X',
          value: '+X',
        },
        {
          key: 'Y',
          value: 'Y',
        },
        {
          key: '-Y',
          value: '-Y',
        },
        {
          key: '+Y',
          value: '+Y',
        },
        {
          key: 'Z',
          value: 'Z',
        },
        {
          key: '-Z',
          value: '-Z',
        },
        {
          key: '+Z',
          value: '+Z',
        },
      ],
      required: true,
      width: '14%',
    },
    {
      name: 'threshold',
      title: 'Пороговое значение (mg)',
      type: 'number',
      required: true,
      width: '14%',
      canBeNegative: true,
    },
    {
      name: 'color',
      title: 'Цвет',
      type: 'color',
      id_type: 'text',
      required: true,
      width: '50px',
      disableFilter: true,
    }
  ],
  newTemplate: {
    accelerometer_param_id: null,
    name: null,
    group: null,
    priority: null,
    value: null,
    axis: null,
    threshold: null,
    color: null,
  },
  createField: 'createdAt',
  updateField: 'updatedAt',
  makeIdOnInsert: true,
  defaultSort: {
    field: 'accelerometer_param_id',
    direction: 'desc'
  },
  import: {
    header: [
      {
        title: 'accelerometer_param_id',
        field: 'accelerometer_param_id',
      },
      {
        title: 'name',
        field: 'name',
      },
      {
        title: 'group',
        field: 'group',
      },
      {
        title: 'priority',
        field: 'priority',
      },
      {
        title: 'value',
        field: 'value',
      },
      {
        title: 'axis',
        field: 'axis',
      },
      {
        title: 'threshold',
        field: 'threshold',
      },
      {
        title: 'color',
        field: 'color',
      }
    ],
    example: `1;Слабый вертикальный удар;1;1;1;Z;300;#00ff00`,
  },

};

export default config;
